import React, { useEffect, useState } from 'react';
import { Chart } from 'primereact/chart';

const LineChart = ({ x, y, yLabel, backgroundColor = false }) => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const data = {
      labels: x,
      datasets: [
        {
          label: yLabel,
          data: y,
          borderColor: 'blue',
          tension: .4,
          fill: backgroundColor,
          backgroundColor: (context) => {
            const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, 400);
            gradient.addColorStop(0, '#427bff');
            gradient.addColorStop(0.955, 'rgba(255, 255, 255)');
            return gradient;
          },
        }
      ]
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: .6,
      plugins: {
        legend: {
          display: false,
        }
      },
      scales: {
        x: {
          ticks: {
            display: true,
          },
          grid: {
            display: false
          }
        },
        y: {
          ticks: {
            display: true,
          },
          grid: {
            color: '#74747526',
            display: true
          }
        }
      }
    };

    setChartData(data);
    setChartOptions(options);
  }, [x, y, yLabel]);

  return (
    <Chart type="line" data={chartData} options={chartOptions} height='300px' />
  )
}

export default LineChart;
